/*
 * VigorX v2 — «Kupi 4, dobij poklon» (port of the Poland gift, 2026-09-22 → 10-12).
 *
 * The gift is a real product (window.VX_GIFT, from snippets/vx-gift-data.liquid)
 * with a real price; the discount function «vigorx-gift» drops ONE unit to 0.01
 * when some product in the cart reaches VX_GIFT.min (4). The function is the
 * final word on price; this file only keeps the gift LINE in step with the cart.
 *
 * Lessons carried over from Poland, each one cost real orders:
 *  - Every gift add/remove goes through one chain (giftChain), never a boolean
 *    lock: a dropped call left the page painted on a stale cart.
 *  - Releasit's own stepper writes through the Storefront API (cartLinesUpdate),
 *    never /cart/change.js, and the form never re-reads the cart if someone else
 *    changes it. So inside the form we press Releasit's OWN remove button
 *    (rsiGuard) instead of editing the cart behind its back.
 *  - Never touch the cart once the shopper has started typing in the form:
 *    the form posts its own lines with the cart's discount and Shopify clips the
 *    difference -> order total 0.00 (#4235, #4422 in Poland).
 *  - Before the form opens, the cart must read the same twice in a row and the
 *    gift line must be there if earned (settle) — the zero-total orders came
 *    from opening on the first snapshot that merely "grew".
 *
 * Also stamps the cart attribute _vx2=1: the discount function ignores carts
 * without it until the shop metafield custom.gift_live is switched on, so the
 * live theme is never affected by any of this.
 *
 * DEBUG  window.vxGift.state()
 */
(function () {
  'use strict';
  if (window.vxGift) return;

  var G = window.VX_GIFT;
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var giftChain = Promise.resolve(false);
  var rsiTouched = false;
  var rsiBusy = false;
  var last = { cart: null, error: null };

  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  var pending = 0;   // speed 2026-10-14: gift syncs queued on giftChain and not finished yet
  function isFullCart(c) {
    return !!(c && Array.isArray(c.items) && typeof c.token === 'string' && typeof c.total_price === 'number');
  }
  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { last.cart = c; return c; });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body), credentials: 'same-origin' });
  }
  function isGiftItem(it) { return G && it.variant_id === G.variantId; }

  /* HU 2026-10-15 (Ahmad, order #6962 = 2+2 got no gift): the gift is earned by
     VX_GIFT.min boxes IN TOTAL, any mix of products (was: min of the same product). */
  function qualifies(cart) {
    if (!G) return false;
    var total = 0;
    (cart.items || []).forEach(function (it) {
      if (isGiftItem(it)) return;                       // the gift never counts towards itself
      total += it.quantity;
    });
    return total >= G.min;
  }
  function giftLine(cart) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) if (isGiftItem(items[i])) return items[i];
    return null;
  }

  /* _vx2=1 on the cart: the function's gate. Once per cart token. */
  function ensureFlag(cart) {
    if (cart.attributes && cart.attributes._vx2 === '1') return Promise.resolve(false);
    return post('/cart/update.js', { attributes: { _vx2: '1' } }).then(function () { return true; });
  }

  // speed 2026-10-14: «known» = the cart the bridge read right after its add. It may only
  // confirm that NOTHING has to change; any write (flag, gift add/qty/remove) is decided on a
  // fresh read, so a stale snapshot can never add a second gift.
  function runSync(known) {
    if (!G) return Promise.resolve(false);
    var read = isFullCart(known) ? Promise.resolve(known) : readCart();
    return read.then(function (cart) {
      if (cart === known) {
        var kl = giftLine(cart), kw = qualifies(cart);
        var flagged = !!(cart.attributes && cart.attributes._vx2 === '1');
        if (!flagged || (kw && (!kl || kl.quantity !== 1)) || (!kw && kl)) return runSync(undefined);
      }
      return ensureFlag(cart).then(function () {
        var line = giftLine(cart), want = qualifies(cart);
        if (want && (!line || line.quantity !== 1)) {
          return (line
            ? post('/cart/change.js', { id: line.key, quantity: 1 })
            : post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] })
          ).then(function () { return true; });
        }
        if (!want && line) {
          return post('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return true; });
        }
        return false;
      });
    }).catch(function (e) { last.error = e; return false; });
  }

  function sync(known) {
    // speed 2026-10-14: a snapshot is only trusted when no other gift sync is still queued;
    // the explicit wrapper also stops .then(runSync) passing the previous boolean in as «known»
    if (pending > 0) known = undefined;
    pending++;
    var run = function () { return runSync(known); };
    var done = function () { pending--; };
    giftChain = giftChain.then(run, run);
    giftChain.then(done, done);
    return giftChain;
  }

  /* The cart page renders the gift row without remove/stepper; after the engine
     changes the cart behind the theme, repaint so rows never vanish one by one
     while the real cart stays put (Poland «cart won't empty»). */
  function syncAndRepaint() {
    return sync().then(function (changed) {
      if (changed && window.vxCod && typeof window.vxCod.refresh === 'function') return window.vxCod.refresh();
      return null;
    });
  }

  /* Called by vx-cod-bridge right before the COD form opens: gift line correct,
     then two identical reads in a row (max ~3 s so buying never hangs). */
  function settle(known) {
    if (!G) return Promise.resolve(null);
    var useKnown = isFullCart(known) && pending === 0;
    var sig = function (c) {
      return (c.items || []).map(function (i) { return i.key + 'x' + i.quantity; }).join('|') + '#' + c.total_price;
    };
    var deadline = Date.now() + 3000;
    return sync(useKnown ? known : undefined).then(function (changed) {
      // speed 2026-10-14: when the sync changed nothing, the caller's post-add read is the first
      // of the «two identical reads»; one fresh read that matches it is enough (else: original loop)
      var prev = useKnown && changed === false ? sig(known) : null;
      return (function poll() {
        return readCart().then(function (c) {
          var s = sig(c);
          // 2026-10-14: exactly one gift when earned, none when not (a stray or doubled gift line
          // used to pass this check and bill the second unit at full price)
          var gl = giftLine(c);
          var giftOk = qualifies(c) ? !!(gl && gl.quantity === 1) : !gl;
          if (s === prev && giftOk) return c;
          prev = s;
          if (Date.now() > deadline) return c;
          if (!giftOk) return sync().then(function () { return delay(250); }).then(poll);
          return delay(250).then(poll);
        });
      })();
    }).catch(function (e) { last.error = e; return null; });
  }

  /* ---------- inside the Releasit form ---------- */
  function rsiForm() { return document.querySelector('.rsi-form-main, #rsi_form_wrapper'); }
  function rsiOpen() { var f = rsiForm(); return !!(f && f.offsetHeight); }
  function rsiRows() { return [].slice.call(document.querySelectorAll('.rsi-product-item-wrapper')); }
  function rsiIsGiftRow(w) {
    var nameEl = w.querySelector('.rsi-product-item-name');
    var nm = nameEl ? nameEl.textContent.trim().toLowerCase() : '';
    var img = w.querySelector('img');
    var src = img ? String(img.getAttribute('src') || '') : '';
    return nm.indexOf(String(G.title).toLowerCase()) === 0 || src.indexOf(G.handle) !== -1;
  }
  function watchTyping() {
    ['input', 'change', 'keydown'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var t = e.target;
        if (!t || !t.closest || !/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
        if (t.closest('.rsi-form-main, #rsi_form_wrapper')) rsiTouched = true;
      }, true);
    });
  }

  /* Dropped below the threshold inside the form -> press Releasit's own remove
     on the gift row. Going UP inside the form is left alone on purpose: adding a
     line needs a cart edit behind the form, which is exactly what produced the
     zero-total orders. The PDP pack selector is where 4 is chosen. */
  function rsiClick(row, cls) {
    var b = row.querySelector('button.' + cls);
    if (b) { b.click(); return true; }
    return false;
  }
  /* The form builds its state from ITS OWN mutation response, never from /cart.js. After we
     add the gift behind it, a «+ then −» on a normal row makes Releasit mutate and re-read the
     whole cart (gift included). Checked that «+» really happened before pressing «−», so the
     shopper's quantity is never reduced (Poland 2026-09-22). */
  function rsiNudge(countBefore) {
    if (rsiTouched) return Promise.resolve();
    var row = null, rows = rsiRows();
    for (var i = 0; i < rows.length; i++) if (!rsiIsGiftRow(rows[i])) { row = rows[i]; break; }
    if (!row) return Promise.resolve();
    if (!rsiClick(row, 'rsi-quantity-increase')) return Promise.resolve();
    return delay(1500).then(readCart).then(function (c) {
      if (c.item_count === countBefore + 1) { rsiClick(row, 'rsi-quantity-decrease'); return delay(1200); }
      if (!rsiClick(row, 'rsi-quantity-decrease')) return null;
      return delay(1500).then(readCart).then(function (c2) {
        if (c2.item_count === countBefore - 1) rsiClick(row, 'rsi-quantity-increase');
        return delay(1200);
      });
    });
  }
  function tagGiftRows() {
    if (!G) return;
    rsiRows().forEach(function (w) { w.classList.toggle('vx-rsi-gift', rsiIsGiftRow(w)); });
  }

  function closeEmptyForm() {
    try { if (window._rsiV2 && window._rsiV2.setState) window._rsiV2.setState({ isOpen: false }); } catch (e) {}
    rsiTouched = false;
    if (window.vxCod && typeof window.vxCod.refresh === 'function') window.vxCod.refresh();
  }

  function rsiGuard() {
    if (!G || rsiBusy) return;
    var form = rsiForm();
    if (!form || !form.offsetHeight) { rsiTouched = false; return; }
    rsiBusy = true;
    tagGiftRows();
    readCart().then(function (cart) {
      /* cart emptied from inside the form (last product removed -> the gift goes with it):
         Releasit then shows a price-less placeholder line, so close the form instead. */
      if (!(cart.items || []).length) { closeEmptyForm(); return null; }
      /* back up to the threshold inside the form -> gift comes back, but ONLY before the
         shopper starts typing: adding behind a form that is about to submit is exactly what
         produced the zero-total orders (#4235/#4422). After typing, the gift just stays out. */
      if (!giftLine(cart) && qualifies(cart) && !rsiTouched) {
        // no «Artikl je dodan» popup behind the open form for the gift add
        document.documentElement.classList.add('vx-buying');
        clearTimeout(window.__vxBuyingT);
        window.__vxBuyingT = setTimeout(function () { document.documentElement.classList.remove('vx-buying'); }, 8000);
        return post('/cart/add.js', { items: [{ id: G.variantId, quantity: 1 }] })
          .then(function () {
            // preferred: re-read the cart into the open form (no visible quantity change);
            // fallback to the Poland «+ then −» nudge only if that read is unavailable/fails
            if (window.vxCod && typeof window.vxCod.reloadForm === 'function') {
              return window.vxCod.reloadForm().then(function (ok) { return ok ? null : rsiNudge(cart.item_count + 1); });
            }
            return rsiNudge(cart.item_count + 1);
          })
          .then(function () { tagGiftRows(); });
      }
      if (giftLine(cart) && !qualifies(cart)) {
        var rows = rsiRows();
        for (var i = 0; i < rows.length; i++) {
          if (!rsiIsGiftRow(rows[i])) continue;
          // the remove button is a DIRECT child — without :scope it matches row 1's
          var rm = rows[i].querySelector(':scope > .rsi-product-item-remove');
          if (rm) rm.click();
          break;
        }
        // if the gift was the last line, the cart is now empty -> close the form
        return delay(1600).then(readCart).then(function (c) { if (!(c.items || []).length) closeEmptyForm(); });
      }
    }).catch(function (e) { last.error = e; })
      .then(function () { setTimeout(function () { rsiBusy = false; }, 900); });
  }

  /* ---------- fetch hook: react to every cart write that isn't ours ---------- */
  function hook() {
    var orig = window.fetch;
    var gid = G ? String(G.variantId) : '\u0000';
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var body = init && typeof init.body === 'string' ? init.body : '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var isOurs = isCartWrite && (body.indexOf(gid) !== -1 || body.indexOf('"_vx2"') !== -1);
      var isSfCart = url.indexOf('/api/') !== -1 && url.indexOf('graphql.json') !== -1 && body.indexOf('cartLines') !== -1;
      var out = orig.apply(this, arguments);
      if (isCartWrite && !isOurs) out.then(function (r) { if (r && r.ok && !rsiOpen()) setTimeout(syncAndRepaint, 120); return r; }).catch(function () {});
      if (isSfCart) out.then(function (r) { setTimeout(rsiGuard, 700); return r; }).catch(function () {});
      return out;
    };
  }

  if (G && 'MutationObserver' in window) {
    var tagT = 0;
    new MutationObserver(function () { if (!tagT) tagT = setTimeout(function () { tagT = 0; tagGiftRows(); }, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }

  window.vxGift = {
    sync: sync,
    settle: settle,
    qualifies: qualifies,
    rule: G || null,
    state: function () { return { rule: G || null, rsiTouched: rsiTouched, cart: last.cart, error: last.error && String(last.error) }; }
  };

  if (!G) return;   // no gift product published yet -> engine stays idle
  hook();
  watchTyping();
  setTimeout(syncAndRepaint, 400);
})();
